import axios from 'axios'
import { QueryKey } from '@tanstack/react-query'
import {
  TGetRecipeAvailabilities,
  TRecipeAvailability,
  TSummaryAvailabilityRecipe,
} from '@mindfulchefuk/types/recipeAvailabilities'
import { transformRecipeAvailabilitiesSummaryData } from '@mindfulchefuk/helpers/dataTransforms/transformRecipeAvailabilitiesData'
import errorHandler from '@mindfulchefuk/utils/errorHandler'

export const fetcherGetRecipeAvailabilities = ({
  queryKey,
}: {
  queryKey: QueryKey
}): Promise<TRecipeAvailability<TSummaryAvailabilityRecipe>[]> => {
  const [, { deliveryDate, portionCount, mealPlan }] = queryKey as [
    string,
    TGetRecipeAvailabilities
  ]

  return axios
    .get(
      `${process.env.NEXT_PUBLIC_API_URL}/v2/recipe_availabilities?meal_plan=${mealPlan}&portion_count_per_meal=${portionCount}&delivery_date=${deliveryDate}`,
      {
        method: 'GET',
      }
    )
    .then((response) => transformRecipeAvailabilitiesSummaryData(response.data))
    .catch((err) => {
      errorHandler(err)
      return null
    })
}
